import { Form } from 'antd';
import './tableConfig.css';
import { defaultInfoCardConfiguration } from '../../../constants/constants';
import { mergeConfigurationInfoCardStyles } from '../../../utils/styles';
import {
  INFO_CARD_STYLE_PRESETS,
  infoCardPresetTemplates,
  infoCardStylePatch,
} from '../../../shared/boxes/infoCard/infoCardStyles';
import InfoCardFields from '../../common/boxStyleFields/InfoCardFields';
import BoxStyleTemplatePicker from '../../common/boxStyleFields/BoxStyleTemplatePicker';
import BoxStyleList from './BoxStyleList';
import { useBoxStyleTab } from './useBoxStyleTab';
import { useShareWithConfigPreview } from '../../../contexts/ConfigPreviewContext';
import InfoCardPreview from './InfoCardPreview';

/**
 * Modèles de Carte info du template.
 *
 * Le site propose une galerie de neuf styles tout faits (chiffre clé,
 * témoignage, membre d'équipe…) : elle sert ici de **point de départ**, à
 * ajuster ensuite. Un style n'est jamais qu'un jeu de valeurs, des deux côtés.
 *
 * Les champs sont exactement ceux du panel de droite d'une carte, à une
 * exception près : la photo appartient à la carte, pas au modèle.
 */
export const TabsInfoCard = () => {
  const {
    styleList, selectedStyle, selectedStyleId, locked, listHandlers,
    setProp, setProps, labelOfColor, colorOfLabel,
  } = useBoxStyleTab({
    configKey: 'infoCardStyles',
    defaultStyle: defaultInfoCardConfiguration,
    mergeStyles: mergeConfigurationInfoCardStyles,
  });
  // Style montré sur la page d'aperçu du Drawer.
  useShareWithConfigPreview('infoCardStyleId', selectedStyleId);

  return (
    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
      <BoxStyleList
        title="Liste des modèles de cartes info"
        styles={styleList}
        selectedId={selectedStyleId}
        {...listHandlers}
      />

      <div style={{ display: 'flex', flexDirection: 'column', width: '60%', margin: 20 }}>
        <div style={{ width: '100%' }} key={selectedStyleId}>
          <Form.Item label="Partir d'un modèle" style={{ marginBottom: 16 }}>
            {/* Vignettes plutôt qu'une liste déroulante : on voit ce qu'on
                choisit, comme la galerie du site et le sélecteur de
                dispositions du document. Le modèle emporte son texte
                d'exemple, qui suivra sur les cartes de démonstration. */}
            <BoxStyleTemplatePicker
              styles={infoCardPresetTemplates()}
              props={selectedStyle}
              onApply={(preset) => {
                const def = INFO_CARD_STYLE_PRESETS.find((p) => p.key === preset.id);
                if (def) setProps({ ...infoCardStylePatch(def), sample: def.sample });
              }}
              renderPreview={(preset) => <InfoCardPreview style={preset} />}
            />
          </Form.Item>

          <InfoCardFields
            style={selectedStyle}
            locked={locked}
            setProp={setProp}
            labelOfColor={labelOfColor}
            colorOfLabel={colorOfLabel}
          />
        </div>
      </div>
    </div>
  );
};

export default TabsInfoCard;
